module.exports = __webpack_public_path__ + "static/media/tc.006015e5.svg";